<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
<div class="btn-group"
     role="group">
    <div>
        <button (click)="onOpenModal(createFolderView)"
                *ngIf="isCreateFolder"
                class="btn btn-primary btn-sm"
                data-action="createFolder">
            <span>{{ 'DOCUMENTS.BUTTONS.CREATE_FOLDER' | translate }}</span>
        </button>
    </div>

    <button (click)="onOpenUploadModal(createFileView)"
            *ngIf="isCreateCollection"
            class="btn btn-primary btn-sm"
            data-action="createDocument"
            style="margin-left: 10px;">
        <span>{{ 'DOCUMENTS.BUTTONS.UPLOAD_FILE' | translate }}</span>
    </button>
</div>
<small *ngIf="isCreateCollection"><br>{{ 'DOCUMENTS.TEXT.FAST_UPLOAD' | translate }}</small>


<ng-template #createFolderView
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.CREATE_FOLDER' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }} *</h2>
        <input #FolderName
               aria-describedby="emailHelp"
               class="form-control"
               name="folderName"
               required>
        <small class="form-text text-muted">{{ 'MODALS.TEXT.CREATE_FOLDER' | translate }}</small>
        <small class="form-text text-muted">* {{ 'MODALS.TEXT.REQUIRED' | translate }}</small>
        <h3>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h3>
        <input #FolderDescription
               aria-describedby="emailHelp"
               class="form-control">
        <button (click)="onCreateFolder(FolderName, FolderDescription, modal);"
                [disabled]="isLockButton"
                class="btn btn-success"
                data-action="createFolderButton"
        >
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>


<ng-template #createFileView
             let-modal>
    <app-button-modal-close (closeEmit)="selectedMember = null"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.UPLOAD_FILE' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.FILE' | translate }}</h2>
        <div class="custom-file">
            <input #file
                   class="form-control"
                   id="customFile"
                   multiple
                   type="file">
            <label class="form-label"
                   data-browse="{{ 'BUTTON_TEXT.SELECT' | translate }}"
                   for="customFile"
            >
                {{ file.files.length ? ('MODALS.FIELDS.SELECT.FILES' | translate:{total: file.files.length}) : ('MODALS.FIELDS.SELECT.EMPTY' | translate) }}
            </label>
        </div>

        <label *ngIf="!isCollection"
               class="mt-3">
            <input #oneCollection
                   (change)="isChecked = oneCollection.checked"
                   [checked]="isChecked"
                   style="width: auto;"
                   type="checkbox">
            {{ 'MODALS.FIELDS.ONE_COLLECTION' | translate }}?
        </label>

        <div class="custom-control custom-checkbox"
             style="margin-top: 5px;">
            <input class="custom-control-input"
                   disabled
                   id="customCheck1"
                   type="checkbox">
            <label class="custom-control-label"
                   for="customCheck1">{{ 'MODALS.FIELDS.CRYPTO' | translate }}</label>
        </div>

        <div class="mb-3"
             style="text-align: left; margin-top: 15px;">
            <h2 style="margin-bottom: -3px;">{{ 'MODALS.FIELDS.FILES_DESCRIPTION' | translate }}</h2>
            <textarea #fileDescription
                      class="form-control"
                      placeholder="{{ 'MODALS.TEXT.FILE_DESCRIPTION' | translate }}"></textarea>
        </div>

        <div class="mb-3"
             style="text-align: left;">
            <h2 style="margin-bottom: -3px;">{{ 'MODALS.FIELDS.COLLECTION_DESCRIPTION' | translate }}</h2>
            <textarea #collectionDescription
                      class="form-control"
                      id="validationTextarea"
                      placeholder="{{ 'MODALS.TEXT.COLLECTION_DESCRIPTION' | translate }}"></textarea>
        </div>

        <h2 class="list-group"
            style="margin-top: -5px;">{{ 'MODALS.FIELDS.SIGNERS' | translate }}</h2>
        <div class="list-group">
            <a (click)="removeSigner(item)"
               *ngFor="let item of signers"
               [class.blocked_user]="item.project_setting.observation_type === 'blocked'"
               [class.inactive_user]="!item.is_active"
               class="list-group-item list-group-item-action"
               ngbTooltip="{{ 'MODALS.BUTTONS.DELETE_USER' | translate }}"
            >
                <img *ngIf="item.project_setting.is_project_admin"
                     alt="#"
                     ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                     src="../../../../assets/images/admin.svg">
                {{ helper.fullName(item) }}
                <i class="bi bi-person-dash-fill float-end"></i>
            </a>
        </div>

        <select (change)="signatories()"
                [(ngModel)]="selectedMember"
                class="form-select"
                style="margin-top: 10px">
            <option [ngValue]="null"
                    hidden> {{ 'MODALS.FIELDS.SELECT.ADD_SIGNER' | translate }}
            </option>
            <option *ngFor="let item of allMembers"
                    [class.inactive_user]="!item.is_active"
                    [ngValue]="item">
                {{ helper.fullName(item) }}
            </option>
        </select>

        <button (click)="onCreateCollectionOrFile(file, fileDescription, collectionDescription, modal)"
                [disabled]="isLockButton"
                class="btn btn-success mt-1"
                data-action="createDocumentButton"
        >
            <span *ngIf="!isLockButton else refresh">
                {{ 'MODALS.BUTTONS.UPLOAD' | translate }}
            </span>
        </button>
    </div>
</ng-template>
